var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCstDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_613_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3905 4.25V0H1.1405C0.724878 0 0.390503 0.334375 0.390503 0.75V15.25C0.390503 15.6656 0.724878 16 1.1405 16H11.6405C12.0561 16 12.3905 15.6656 12.3905 15.25V5H8.1405C7.728 5 7.3905 4.6625 7.3905 4.25ZM9.77957 10.855L6.76644 13.8456C6.55863 14.0522 6.223 14.0522 6.01519 13.8456L3.00207 10.855C2.68488 10.5403 2.90738 10 3.35363 10H5.3905V7.5C5.3905 7.22375 5.61425 7 5.8905 7H6.8905C7.16675 7 7.3905 7.22375 7.3905 7.5V10H9.42738C9.87363 10 10.0961 10.5403 9.77957 10.855ZM12.1718 3.28125L9.11238 0.21875C8.97175 0.078125 8.78113 0 8.58113 0H8.3905V4H12.3905V3.80938C12.3905 3.6125 12.3124 3.42188 12.1718 3.28125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_613_1534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(0.390503)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCstDownload);
export default __webpack_public_path__ + "static/media/cst-download.d6c203a21ee7bc2528e16916c8a4e546.svg";
export { ForwardRef as ReactComponent };